var map = {
	"./jianruo.png": "2287",
	"./jiantou1.png": "00da",
	"./jiantou2.png": "f358",
	"./jiantou3.png": "47e6",
	"./jiaqiang.png": "d9d7",
	"./pingfen-bg.png": "1f58",
	"./pingheng.png": "5f63",
	"./乙状结肠.png": "82ce",
	"./十二指肠.png": "2ec0",
	"./升结肠.png": "9f4d",
	"./小肠.png": "32d9",
	"./横结肠.png": "42b9",
	"./盲肠.png": "c8e8",
	"./直肠.png": "8da4",
	"./肝.png": "8831",
	"./胃.png": "c076",
	"./胆囊.png": "ff0f",
	"./胰腺.png": "d750",
	"./降结肠.png": "42be",
	"./食管.png": "fbbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f18e";